import { Assets } from 'pixi.js';
import { GameApp } from './GameApp.js';
import { patchPixiAssetLoader } from './utils/assetUrl.js';

patchPixiAssetLoader(Assets);

/**
 * Wrapped in an async IIFE instead of using top-level `await`.
 * Top-level await requires Safari 15+ / iOS 15+ / Chrome 89+, so emitting it
 * makes the entire module fail to parse on iOS 12–14 and old Android WebView.
 * The build target (see `vite.config.js`) is also lowered so syntax like `?.`
 * and `??` is transpiled for these same browsers.
 */
(async () => {
  try {
    const game = new GameApp();
    await game.init(document.body);
  } catch (err) {
    console.error(err);
  }
})();
